import {TextStyleParams} from '@gongxigames/framework/slot';

export const buyButtonStyle: TextStyleParams = {
    align: 'center',
    dropShadow: false,
    dropShadowAlpha: 20,
    dropShadowAngle: 90,
    dropShadowBlur: 20,
    dropShadowDistance: 4,
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 60
};
export const buyPopUpStyle: TextStyleParams = {
    align: 'center',
    dropShadow: false,
    dropShadowAlpha: 20,
    dropShadowAngle: 90,
    dropShadowBlur: 20,
    dropShadowDistance: 4,
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 190
};
export const buyPopUpNotEnoughRubyStyle: TextStyleParams = {
    align: 'center',
    fill: ['#818181'],
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 100,
    fontWeight: 'bold',
    strokeThickness: 8
};
export const buyPopUpBetStyle: TextStyleParams = {
    align: 'center',
    dropShadow: false,
    dropShadowAlpha: 20,
    dropShadowAngle: 90,
    dropShadowBlur: 20,
    dropShadowDistance: 4,
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10,
    fontSize: 150
};
export const costInRubiesStyle: TextStyleParams = {
    fill: '#e10000',
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 190,
    fontWeight: 'bold',
    lineJoin: 'bevel',
    miterLimit: 0,
    stroke: 'white',
    strokeThickness: 8
    // maxWidth: 300
};
export const defaultStyle: TextStyleParams = {
    align: 'center',
    dropShadow: false,
    dropShadowAlpha: 20,
    dropShadowAngle: 90,
    dropShadowBlur: 20,
    dropShadowDistance: 4,
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#84230f',
    strokeThickness: 10
};
export const defaultStyleForPick: TextStyleParams = {
    align: 'center',
    dropShadow: false,
    dropShadowAlpha: 20,
    dropShadowAngle: 90,
    dropShadowBlur: 20,
    dropShadowDistance: 4,
    fontFamily: 'PF DinDisplay Pro',
    fontWeight: 'bold',
    fill: [
        '#f48e0c',
        '#fff88b',
        '#f9ffd5',
        '#fff88b',
        '#ffcb2a',
        '#ffcb2a',
        '#f48e0c'
    ],
    stroke: '#080808',
    strokeThickness: 15,
    leading: -30
};
